import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { memo } from "react";

import Logo from "@/components/Core/Logo";

interface BrandSectionProps {
  description: string;
}

export const BrandSection = memo(({ description }: BrandSectionProps) => {
  return (
    <Stack sx={{ gap: 2, alignItems: { xs: "center", md: "flex-start" } }}>
      <Logo fullWidth />
      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 420, whiteSpace: "pre-line", textAlign: { xs: "center", md: "left" } }}
        >
          {description}
        </Typography>
      )}
    </Stack>
  );
});
BrandSection.displayName = "BrandSection";
